import React from "react";
import { Section, Reveal, Eyebrow } from "./ui";
const items = ["Cada mañana salir para la escuela parece una carrera contra el reloj.", "Hay días en los que una pequeña situación termina en una crisis enorme.", "Sentís que todos opinan diferente y ya no sabés qué hacer.", "Guardaste decenas de videos, publicaciones y consejos… pero nada forma un camino claro.", "Querés ayudarlo, pero muchas veces terminás reaccionando por intuición."];
export function Identification() {
  return <Section id="identificacion" className="bg-[var(--calm-blue)]/40" data-id="element-143" data-mp="22b49v6zsv2ru">
      <Reveal className="text-center" data-id="element-144" data-mp="2g9viwezt1y94">
        <Eyebrow data-id="element-145" data-mp="2gawv4msk4qsf">Quizás te suene familiar</Eyebrow>
        <h2 className="mx-auto max-w-3xl font-serif-display text-3xl font-semibold leading-tight text-[var(--ink)] sm:text-4xl" data-id="element-146" data-mp="2bb0pkj47orar">
          Si convivís con un niño con TDAH o Autismo… esto probablemente te
          resulte familiar.
        </h2>
      </Reveal>

      <div className="mt-7 grid grid-cols-2 gap-2.5 sm:mt-10 sm:gap-4" data-id="element-147" data-mp="3mpo0b2opqxs9">
        {items.map((t, i) => <Reveal key={t} delay={i * 0.05} data-id="element-148" data-mp="1yfi5if8f9fs1" data-mpi={i}>
            <div className="flex h-full flex-col items-center gap-2 rounded-2xl border border-[#e6eef5] bg-white p-3 text-center shadow-[0_10px_30px_-22px_rgba(31,51,69,0.4)] sm:flex-row sm:items-start sm:gap-4 sm:p-5 sm:text-left" data-id="element-149" data-mp="22h3g1txhhhz2">
              <span className="text-lg leading-none sm:text-2xl" aria-hidden data-id="element-150" data-mp="2ce82zvz5lhgx">😔</span>
              <p className="text-[11px] leading-snug text-[var(--muted)] sm:text-sm sm:leading-relaxed" data-id="element-151" data-mp="1estw6xjtz4ak">{t}</p>
            </div>
          </Reveal>)}
      </div>

      <Reveal delay={0.1} data-id="element-152" data-mp="1opyicxdoezrd">
        <div className="mt-3 rounded-2xl border border-[#e6eef5] bg-white p-4 text-center shadow-[0_10px_30px_-22px_rgba(31,51,69,0.4)] sm:mt-4 sm:p-6" data-id="element-153" data-mp="1opownlznzerh">
          <p className="text-sm text-[var(--muted)]" data-id="element-154" data-mp="1tihzg4bkod0x">
            Y al final del día aparece esa sensación de culpa de pensar:
          </p>
          <p className="mt-2 font-serif-display text-xl text-[var(--ink)]" data-id="element-155" data-mp="10zm311g3q0qr">
            “¿Y si podría haberlo hecho mejor?”
          </p>
        </div>
      </Reveal>
    </Section>;
}